import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { UsersComponent } from './users.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown/multiselect.component';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { RouterModule } from '@angular/router';
import { UiSwitchModule } from 'ng2-ui-switch';
import { NgxPaginationModule } from 'ngx-pagination';

@NgModule({
    imports: [
        CommonModule,
        NgxPaginationModule,
        SharedModule,
        AngularMultiSelectModule,
        FormsModule,
        HttpModule,
        RouterModule,
        UiSwitchModule
    ],
    exports: [NgxPaginationModule],
    declarations: [UsersComponent],
    providers: [],
})
export class UsersModule { }



// WEBPACK FOOTER //
// ./src/app/views/users/users.module.ts